// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FollowerItem_wrapper__xDCdS","userInfo":"FollowerItem_userInfo__1sj4X","avatar":"FollowerItem_avatar__krSG_","userAction":"FollowerItem_userAction__7YOfV"};